import React from 'react';
import type { SavedLocation } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useSavedLocationDrawerStore } from '@hero/hooks-shared';
import { TableCell } from '../../../ui/Table/Table';
import { LocationIcon } from '@hero/web-icons';
import { CellAction } from '../../../app/Table/CellAction';
import { ClientDisplay } from '../../Client/ClientDisplay';
import { ContactsTooltipDisplay } from '../../Contact/ContactsTooltipDisplay';

export interface SavedLocationRowProps {
  location: SavedLocation;
}

export const SavedLocationRow: React.FC<SavedLocationRowProps> = ({ location }) => {
  const { t } = useTranslation(['m-location']);
  const openDrawer = useSavedLocationDrawerStore(s => s.open);
  const handleClick = () => openDrawer(String(location._id));

  return (
    <>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <div className="flex items-center gap-3">{location.name}</div>
      </TableCell>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <div className="flex items-center gap-2">
          <LocationIcon className="w-4 h-4 text-gray-500" />
          <span>
            {location.address.city?.name || '—'}, {location.address.country.name}
          </span>
        </div>
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        {location.client?.name ? (
          <ClientDisplay clientName={location.client.name} />
        ) : (
          <span className="text-sm text-gray-500">{t('location_type.my_location.title')}</span>
        )}
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        <ContactsTooltipDisplay
          contacts={location.contacts?.map(c => ({
            name: c.name,
            phone: c.phone || '',
            email: c.email,
          }))}
          headerTitle={t('table.columns.contact')}
        />
      </TableCell>
      <TableCell>
        <CellAction type="view" onClick={handleClick} />
      </TableCell>
    </>
  );
};
